module.exports = __webpack_public_path__ + "img/pic-AIapplication.95722feb.jpg";